import defineComponent from 'flight';
import memberInfo from 'static/script/app/data/member-info';
import cartService from 'static/script/app/data/cart-service';
import uiEffects from 'static/script/utils/ui-effects';
import formatNumber from 'static/script/utils/format-number';

function CartMerchantUI() {

    this.defaultAttrs({
        checkoutAction: '[data-view-cart-button]',
        cartItem: '[data-view-cart-item]',
        orderRowSum: '[data-view-cart-row-price]',
        orderTotalSum: '[data-view-cart-order-sum]',
        orderShippingOptions: '[data-view-cart-shipping-options]',
        orderShippingSum: '[data-cart-shipping-sum]',
        removeMerchantButton: '[data-view-cart-merchant-remove-button]'
    });

    this._goToCheckout = function (evt) {
        evt.preventDefault();
        if (!memberInfo.isLoggedIn) {
            this.trigger(document, 'ui:login:show');
            return;
        }
        let theFirstItemId = this.$node.find('[data-view-cart-quantity]').data('itemid');
        let shippingOption = this.select('orderShippingOptions').find('input:checked').val();
        this.trigger(document, 'ui:cart:on-checkout-start', { itemId: theFirstItemId, shippingType: shippingOption });
    };

    this._changeOrderShipping = function () {
        let shippingOptions = this.select('orderShippingOptions'),
            shippingSum = this.select('orderShippingSum');

        shippingSum.html(formatNumber.asMoney(shippingOptions.find('input:checked').data('unit-price')) + ' kr');
        uiEffects.flashBg(shippingOptions.parents('[data-view-cart-item]'), 'confirm');
        this._calculateTotalPrice();
    };

    this._calculateTotalPrice = function () {
        let orderTotal = 0;

        this.select('orderRowSum').each(function () {
            orderTotal = orderTotal + parseInt($(this).attr('data-row-price'), 10);
        });

        orderTotal = orderTotal + parseInt(this.select('orderShippingSum').html(), 10);
        this.select('orderTotalSum').html(formatNumber.asMoney(orderTotal + ' kr'));
    };

    this._removeItemsFromCart = function (evt) {
        evt.preventDefault();
        let merchant = this.$node,
            itemIds = merchant.find('[data-view-cart-quantity]').map(function () {
                return $(this).data('itemid');
            }).get();

        merchant.fadeOut('fast', function () {
            merchant.remove();
            this.trigger(document, 'ui:cart:on-items-remove', {
                itemIds: itemIds
            });
        }.bind(this));
    };

    this._checkIfCartIsEmpty = function () {
        if (this.select('cartItem').length === 0) {
            this.$node.remove();
        }
    };

    this.after('initialize', function () {
        this.on(document, 'data:cart:after-item-quantity-changed', this._calculateTotalPrice);
        this.on(document, 'ui:cart-after-item-remove', this._checkIfCartIsEmpty);
        this.on(document, 'ui:cart-after-item-remove', this._calculateTotalPrice);

        this.on('click', {
            checkoutAction : this._goToCheckout,
            removeMerchantButton: this._removeItemsFromCart
        });

        this.on('change', {
            orderShippingOptions : this._changeOrderShipping
        });
    });
}

module.exports = defineComponent.component(CartMerchantUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/cart/cart-merchant-ui.js